import { Box } from '@mui/material';
import packageJson from '../../package.json';

const version = packageJson.version;

const Footer = () => {
  return (
    <Box component='footer' sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pt: 2, pb: 'calc(16px + 15px)', gap: 2 }}>
      <small>&copy; {new Date().getFullYear()} Grace Family Church</small>
      <small>v{version}</small>
    </Box>
  );
}

export default Footer;
